import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import { useSuggestedCarouselsBySameAuthor } from "@domain/carousel/hooks";
import { Category } from "@domain/lms/category/category";
import { ContentLanguage } from "@domain/lms/contentLanguage";
import { Carousel as GraphicCarousel } from "@ui/components/carousel/carousel";
import { CarouselThumbnail } from "./carouselThumbnail";

interface CarouselSuggestionsProps extends React.HTMLAttributes<HTMLDivElement> {
	carouselId: string;
	language?: ContentLanguage;
	categories?: Category[] | Category;
}

export const CarouselSuggestions: React.FC<CarouselSuggestionsProps> = ({
	carouselId,
	categories,
	language,
	...htmlProps
}) => {
	const { result: suggestions, loading } = useSuggestedCarouselsBySameAuthor(10, carouselId);

	if (loading && !suggestions) return <ClipLoader />;

	return (
		<GraphicCarousel
			{...htmlProps}
			title={I18n.t("carousel.suggestions")}
			items={carouselId ? suggestions.filter((c) => c && c.id !== carouselId) : suggestions}
			renderItem={(carousel) => <CarouselThumbnail carousel={carousel} />}
			loading={loading}
			itemWidth={316}
			itemHeight={316}
		/>
	);
};
